/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconChevronDown from '@telus-uds/palette-public-mobile/build/rn/icons/ChevronDown'
import PaletteIconChevronUp from '@telus-uds/palette-public-mobile/build/rn/icons/ChevronUp'
const theme = {
  appearances: {
    alternative: {
      description: 'Replaces the default colour with black.',
      type: 'variant',
      values: [ true ]
    },
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inverse: {
      description: 'Replaces the default colour with white.',
      type: 'variant',
      values: [ true ]
    },
    size: { type: 'variant', values: [ 'micro', 'small', 'large' ] }
  },
  rules: [
    {
      if: { expanded: true },
      tokens: { icon: PaletteIconChevronUp }
    },
    {
      if: { alternative: true },
      tokens: { color: '#394056', iconColor: '#394056' }
    },
    {
      if: { inverse: true },
      tokens: { color: '#ffffff', iconColor: '#ffffff' }
    },
    {
      if: { size: 'micro' },
      tokens: { fontSize: 14, iconSize: 16, lineHeight: 1.4 }
    },
    {
      if: { size: 'small' },
      tokens: { fontSize: 16, iconSize: 20, lineHeight: 1.5 }
    },
    {
      if: { size: 'large' },
      tokens: { fontSize: 20, lineHeight: 1.4 }
    }
  ],
  tokens: {
    borderColor: '#394056',
    borderWidth: 0,
    color: '#636c8c',
    fontSize: 18,
    icon: PaletteIconChevronDown,
    iconColor: '#394056',
    iconGap: 16,
    iconPaddingTop: 4,
    iconPosition: 'left',
    iconSize: 24,
    justifyContent: 'flex-start',
    lineHeight: 1.55555555,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    size: 4,
    textLine: 'none',
    verticalAlign: 'middle'
  }
}
export default theme
